/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const GetCounselingMedicalInformationImagesResponseTypename =
  "GetCounselingMedicalInformationImagesResponse" as const;

/**
 *
 * @export
 * @interface GetCounselingMedicalInformationImagesResponse
 */
export interface GetCounselingMedicalInformationImagesResponse {
  /**
   *
   * @type {Array<string>}
   * @memberof GetCounselingMedicalInformationImagesResponse
   */
  urls?: Array<string>;
  /**
   * Resource type name
   * @type {string}
   * @memberof GetCounselingMedicalInformationImagesResponse
   */
  readonly __typename?: string;
}

export function GetCounselingMedicalInformationImagesResponseFromJSON(
  json: any
): GetCounselingMedicalInformationImagesResponse {
  return GetCounselingMedicalInformationImagesResponseFromJSONTyped(json, false);
}

export function GetCounselingMedicalInformationImagesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetCounselingMedicalInformationImagesResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: GetCounselingMedicalInformationImagesResponseTypename,

    urls: !exists(json, "urls") ? undefined : json["urls"],
  };
}

export function GetCounselingMedicalInformationImagesResponseToJSON(
  object?: GetCounselingMedicalInformationImagesResponse | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    urls: value.urls,
  };
}
